import React from "react";
import styled, { css } from "styled-components";
import { encodeHtml } from "../../../utils/string-utils";

export const OffScreenStyles = {
  position: "absolute",
  left: "-10000px",
  top: "auto",
  width: "1px",
  height: "1px",
  overflow: "hidden"
};

export const OffScreenComponent = styled.div`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export class MountOnce extends React.Component {
  state = {
    revealed: this.props.reveal
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.revealed && nextProps.reveal) {
      this.setState({
        revealed: true
      });
    }
  }

  render() {
    if (this.state.revealed) {
      return this.props.children;
    }
    return null;
  }
}

export function UnsafeHtml({ children, tag: Tag = "span", ...restProps }) {
  const unsafeContent = {
    __html: children
  };
  return <Tag dangerouslySetInnerHTML={unsafeContent} {...restProps} />;
}

export function VisibleLineBreaks({ children }) {
  const str = encodeHtml(children);
  return <UnsafeHtml>{str.split("\n").join("<br />")}</UnsafeHtml>;
}

export const fadeInOut = (
  isVisible,
  { inDelayMS = 0, durationMS = 200 } = {}
) => {
  if (isVisible) {
    return css`
      opacity: 1;
      visibility: visible;
      transition: opacity ${durationMS}ms ease-in-out ${inDelayMS}ms,
        visibility 0s;
    `;
  }
  return css`
    opacity: 0;
    visibility: hidden;
    transition: opacity ${durationMS}ms ease-in-out, visibility ${durationMS}ms;
  `;
};

export const primaryShade = index =>
  css`
    ${({ theme }) => theme.vstui.color.primary.getShade(index)}
  `;

export const prettyHTML = css`
  a {
    text-decoration: underline;
    color: ${primaryShade(6)};
    font-weight: 500;
    border-radius: 4px;
    border: 2px solid transparent;
    font-size: inherit;
    &:focus {
      outline: none;
      box-shadow: ${primaryShade(6)} 0px 0px 0px 2px;
    }
  }
  p {
    margin: 12px 0;
  }
  i,
  em {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
`;

export const clampLines = lineCount => css`
  overflow: hidden;
  text-overflow: ellipsis;
  /* stylelint-disable property-no-vendor-prefix */
  /* stylelint-disable value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: ${lineCount};
  -webkit-box-orient: vertical;
  /* stylelint-enable value-no-vendor-prefix */
  /* stylelint-enable property-no-vendor-prefix */
`;

export const studentBannerPadding = (showStudentBanner, isSmall, native) => {
  let paddingTop = "0px";
  if (showStudentBanner && native) {
    paddingTop = "0px";
  } else if (showStudentBanner && isSmall) {
    paddingTop = "117px";
  } else if (showStudentBanner) {
    paddingTop = "72px";
  }
  return css`
    padding-top: ${paddingTop};
  `;
};
